class SampaFactoryPlayer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.querySelector('[data-factory-play]')?.addEventListener('click', () => this.play());
  }

  play() {
    const template = this.querySelector('[data-factory-template]');
    if (!template) return;
    this.appendChild(template.content.cloneNode(true));
    this.classList.add('is-playing');
    this.querySelector('[data-factory-play]')?.remove();
  }
}

if (!customElements.get('sampa-factory-player')) customElements.define('sampa-factory-player', SampaFactoryPlayer);

(() => {
  const initialise = (section) => {
    if (!section || section.dataset.factoryReady === 'true') return;
    section.dataset.factoryReady = 'true';
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    observer.observe(section);
  };

  const initialiseAll = (root = document) => root.querySelectorAll('[data-sampa-factory-section]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
